import { useSettings } from '@/providers/SettingsProvider';

export function formatCurrency(value, currency = 'USD', locale = 'en-US') {
  const { settings } = useSettings();

  if (settings.showPrices) return '*****';

  if (typeof value === 'string') {
    value = parseFloat(value.replace(/[$,]/g, ''));
  }

  if (isNaN(value)) return '$0.00';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}